<script setup lang="ts">
import type { TagInstance } from '@arco-design/web-vue'

const props = defineProps<{
  color?: 'blue' | 'purple' | 'yellow' | 'gray'
  shape?: 'round' | 'circle' | 'square'
  /** 子元素超出父元素时tooltip展示 */
  tooltip?: boolean
}>()

const colorCls = computed(() => {
  return ({
    blue: 'bg-[--color-link-1] text-[--color-link-5]',
    purple: 'bg-[--color-brand-1] text-[--color-brand-6]',
    yellow: 'bg-[--color-warning-1] text-[--color-warning-6]',
    gray: 'bg-[--color-fill-3] text-[--color-text-1]',
  }[props.color as string])
})
const shapeCls = computed(() => {
  return ({
    round: 'rd-full',
    circle: 'rd-50%',
    square: 'rd-2',
  }[props.shape ?? 'round'])
})

const tagRef = ref<TagInstance>()
const showTooltip = computed(() => {
  if (!tagRef.value)
    return false
  return tagRef.value.$el.scrollWidth > tagRef.value.$el.clientWidth
})
</script>

<template>
  <g-tooltip :popup-visible="(!tooltip || !showTooltip) ? false : undefined">
    <a-tag
      ref="tagRef"
      v-bind="$attrs"
      class="h-20 inline-flex px-12 font-400 lh-20"
      :class="[colorCls, shapeCls, $attrs.class]"
    >
      <!-- 覆盖 -->
      <template v-for="(_, key) in $slots" :key="key" #[key]="scope">
        <slot :name="key" v-bind="scope" />
      </template>
    </a-tag>

    <template #content>
      <slot />
    </template>
  </g-tooltip>
</template>

<style scoped>
</style>
